export const APP_VERSION = 'd4fc189f-1790857221965'
